import React, { Component } from 'react';
import { Grid, GridColumn as Column, GridToolbar } from '@progress/kendo-react-grid';
import '@progress/kendo-theme-default/dist/all.css';
import '../ManageUsers/ManageUser.scss';
import { filterBy, orderBy } from '@progress/kendo-data-query';
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';
import GridDateFormatter from '../../../GridDateFormatter';
import cellWithEditing from './CellWithEditing';
import { Switch } from '@progress/kendo-react-inputs';
import { Alert } from 'reactstrap';
import AdminHeader from '../../../AdminHeader/AdminHeader';
import Search from '../../../Search';
import IsLoading from '../../../../Shared/Loading/IsLoading';
import '../ManageOrders/ManageOrders.scss';
import { toastr } from '../../../../../Redux/Actions/CommonActions';
import axios from 'axios';
import { BatchesLoader } from './BatchesLoader';
import { ROOT_API_URL } from '../../../../../api-config';
import { auth } from '../../../../../services/auth.service';
import DialogContainer from './Dialogs/DialogContainer';
import Modal from 'react-modal';

const FileDownload = require('js-file-download');


class ManageBatches extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      isSubmitted: false,
      showMessage: false,
      Message: '',
      batchInEdit: {},
      isPopupVisible: false,
      batches: { data: [], total: 0 },
      dataState: {
        take: 10,
        skip: 0,
        filter: {
          logic: "and",
          filters: [/*{ field: "IsActive", operator: "eq", value: true }*/]
        },
        sort: [{ field: "BatchDate", dir: "desc" }]
      },
      alertVisible: false,
      alertColor: "danger",
      alertMessage: ""

    };
  }

  dataStateChange = (e) => {
    if (e.data && e.data.filter && e.data.filter.filters) {
      var filters = e.data.filter.filters;

      for (var i = 0; i < filters.length; i++) {

        if (filters[i].field && (filters[i].field == "BatchDate" || filters[i].field == "BatchStart" || filters[i].field == "BatchEnd")) {
          var operator = filters[i].operator;

          if ((operator == "gt" || operator == "gte") && !filters[i].value) {

            filters[i].value = new Date('January 01, 1900');

          } else if ((operator == "lt" || operator == "lte") && !filters[i].value) {

            var currentDatetime = new Date();

            filters[i].value = new Date(Date.UTC(currentDatetime.getFullYear(), currentDatetime.getMonth(), currentDatetime.getDate()));

          }
        } else if (filters[i].field && filters[i].field == "BatchJobId" || filters[i].field == "Amount") {
          var operator = filters[i].operator;

          if (!filters[i].value && (operator == "lt" || operator == "lte" || operator == "gt" || operator == "gte")) {

            filters[i].value = 0;

          }

        } else if (filters[i].value == null) {
          filters[i].value = "";
        }
      }
    }

    this.setState({
      ...this.state,
      dataState: e.data
    });
  }

  dataRecieved = (batchesFetched) => {
    this.setState({
      ...this.state,
      batches: batchesFetched,
      isLoading: false
    });
    if (batchesFetched.total == 0 && document.getElementsByClassName("k-grid-header-wrap").length != 0) {
      let t = document.getElementsByClassName("k-grid-header-wrap")[0].className = "horizontal-scroll";
    }
    else if (batchesFetched.total != 0 && document.getElementsByClassName("horizontal-scroll").length != 0) {
      document.getElementsByClassName("horizontal-scroll")[0].className = "k-grid-header-wrap";
    }
  }

  edit = (dataItem) => {
    this.setState({
      batchInEdit: Object.assign({}, dataItem),
      isPopupVisible: true
    });
  };

  cancel = () => {
    this.setState({ isPopupVisible: false })
  };

  deleteBatch = (dataItem) => {
    let model = {
      BatchJobId: dataItem.BatchJobId,
    };

    this.setState({
      isLoading: true,
      isSubmitted: false,
      batchInEdit: {},
      isPopupVisible: false,
      batches: { data: [], total: 0 },
      dataState: {
        take: 10,
        skip: 0,
        filter: {
          logic: "and",
          filters: []
        },
        sort: [{ field: "BatchDate", dir: "desc" }]
      }
    });

    axios.post(`${ROOT_API_URL}/ManageBatches/DeleteBatch`, model, { headers: auth.authHeader() })
      .then((response) => {
        this.setState({
          isSubmitted: true
        });
        this.setState({
          isSubmitted: false
        });
      }).catch((error) => {
        var err = error && error.data ? error.data.message : 'Unable to delete the batch.';

        this.setState({
          isSubmitted: false,
          alertVisible: true,
          alertColor: "danger",
          alertMessage: err
        })
      });
  }

  stringifyObj = (arr) => {
    let t = [...arr];
    if (!t) {
      return null;
    }
    else {
      for (var i = 0; i < t.length; i++) {
        var element = { ...t[i] };
        if (element["field"] === "BatchDate" || element["field"] === "BatchStart" || element["field"] === "BatchEnd") {
          let date = element.value;
          if (!date) {
            date = "01/01/0001";
          }
          else {
            date = (date + '').split(" ");
            let day = date[2] + '';
            let year = date[3] + '';
            let month = "01";
            switch (date[1]) {
              case "Jan":
                month = "01";
                break;
              case "Feb":
                month = "02";
                break;
              case "Mar":
                month = "03";
                break;
              case "Apr":
                month = "04";
                break;
              case "May":
                month = "05";
                break;
              case "Jun":
                month = "06";
                break;
              case "Jul":
                month = "07";
                break;
              case "Aug":
                month = "08";
                break;
              case "Sep":
                month = "09";
                break;
              case "Oct":
                month = "10";
                break;
              case "Nov":
                month = "11";
                break;
              case "Dec":
                month = "12";
                break;
            }
            date = month + "/" + day + "/" + year;
            element["value"] = date;
          }
        }
        else {
          for (var key in t[i]) {
            element[key] = element[key] + '';
          }
        }
        t[i] = element;
      }
      return t;
    }
  }

  exportToExcel = () => {
    var Filters = this.state.dataState.filter ? this.stringifyObj([...this.state.dataState.filter.filters]) : null;
    var Sorts = this.state.dataState.sort ? this.stringifyObj([...this.state.dataState.sort]) : null;
    var KendoGridQuery = {
      Filters: Filters ? Filters.slice() : [],
      Sorts: Sorts ? Sorts.slice() : []
    }

    axios.get(ROOT_API_URL + "/ManageBatches/ExportToExcel?queryArguments=" + JSON.stringify(KendoGridQuery), { headers: auth.authHeader() })
      .then((response) => {
        FileDownload(response.data, 'Batches.csv');
      }).catch((error) => {
        var err = error && error.data ? error.data.message : 'Unable to export to excel.';

        this.setState({
          alertVisible: true,
          alertColor: "danger",
          alertMessage: err
        })
      });
  }

  pageChange = (event) => {
    this.setState({
      skip: event.page.skip,
      take: event.page.take
    });
  }

  DownloadBatchReport = (BatchJobId) => {
    var that = this;
    axios.get(`${ROOT_API_URL}/ManageBatches/GetBatchJobDocument?BatchJobId=${BatchJobId}`, { headers: auth.authHeader() })
      .then((response) => {
        FileDownload(response.data, 'Batch_report.csv');
      }).catch(function (error) {
        that.setState({
          showMessage: true, Message: 'This file could not be found in storage.'
        });
      });
  }

  setAlert = (visible, message, color) => {
    let alert = {
      color: color,
      visible: visible,
      message: message
    }
    this.setState({
      alert: alert
    })
  }

  addNew = () => {
    this.setState({
      isPopupVisible: true,
      batchInEdit: {}
    });
  }

  save = (dataItem) => {
    let model = {
      BatchStatusId: dataItem.BatchStatus.id,
      BatchTypeId: dataItem.BatchType.id,
      BatchDate: dataItem.BatchDate,
      BatchJobId: dataItem.BatchJobId,
      BatchName: dataItem.BatchName
    };

    this.setState({
      isLoading: true,
      isSubmitted: false,
      batchInEdit: {},
      isPopupVisible: false,
      batches: { data: [], total: 0 },
      dataState: {
        take: 10,
        skip: 0,
        filter: {
          logic: "and",
          filters: []
        },
        sort: [{ field: "BatchDate", dir: "desc" }]
      }
    });

    axios.post(`${ROOT_API_URL}/ManageBatches/SaveBatch`, model, { headers: auth.authHeader() })
      .then((response) => {
        this.setState({
          isSubmitted: true
        });
        this.setState({
          isSubmitted: false
        });
      }).catch((error) => {
        var err = error && error.data ? error.data.message : 'Unable to save the batch.';

        this.setState({
          isSubmitted: true
        });

        this.setState({
          isSubmitted: false,
          alertVisible: true,
          alertColor: "danger",
          alertMessage: err
        })
      });
  }

  toggleStatus = (dataItem) => {
    this.save(dataItem);
  }

  closeMessage = () => {
    this.setState({ showMessage: false });
  }


  render() {
    return (
      <div id={"batches-grid"}>
        <AdminHeader />
        {this.state.isLoading ?
          (
            <div>
              <IsLoading message="Loading batches" />
            </div>

          ) :
          (
            <div>
              <Alert
                color={this.state.alertColor}
                isOpen={this.state.alertVisible}
                toggle={() => {
                  this.setState({ alertVisible: false, alertMessage: "" })
                }}
              //style={{ position: 'fixed', width: '100%', height: '50px', zIndex: '1', top: '2px', left: '0' }}
              >
                {this.state.alertMessage}
              </Alert>
              <Grid
                style={{ width: '80vw', height: '80vh' }}
                filterable={true}
                sortable={true}
                pageable={true}
                total={this.state.batches.total}
                {...this.state.dataState}
                {...this.state.batches}
                onDataStateChange={this.dataStateChange}
                resizable
                reorderable={true}
              >
                <GridToolbar>
                  <div className="admin-grid-toolbar-box2">
                    <button onClick={this.addNew} className="admin-k-button">
                      <i className="fas fa-plus-circle"></i>
                      <span>ADD NEW</span>
                    </button>
                    <button title="Export PDF" className="admin-k-button" onClick={this.exportToExcel}>
                      <i className="fas fa-file-export"></i>
                      EXPORT TO EXCEL
                    </button>
                  </div>
                </GridToolbar>
                <Column filterable={false} cell={cellWithEditing(this.edit, this.DownloadBatchReport)} />
                <Column field="BatchJobId" title="Batch Number" filter="numeric" />
                <Column field="BatchName" title="Batch Name" filter="text" />
                <Column field="BatchStatus" title="Batch Status" filter="text" />
                <Column field="BatchType" title="Batch Type" filter="text" />
                <Column field="BatchSource" title="Batch Source" filter="text" />
                <Column field="Amount" title="Total Amount" className="align-cells-right" filter="numeric" format="{0:c2}" />
                <Column field="BatchDate" title="Batch Date" filter="date" cell={GridDateFormatter} />
                <Column field="BatchStart" title="Batch Start" filter="date" cell={GridDateFormatter} />
                <Column field="BatchEnd" title="Batch End" filter="date" cell={GridDateFormatter} />
              </Grid>
            </div>
          )
        }
        <div>
          {
            this.state.isPopupVisible ? (
              <Modal
                isOpen={Boolean(this.state.batchInEdit)}
                onRequestClose={this.cancel}
                contentLabel="Example Modal"
                ariaHideApp={false}
                style={{
                  content: {
                    top: '50%',
                    left: '50%',
                    right: 'auto',
                    bottom: 'auto',
                    marginRight: '-50%',
                    minWidth: '80vw',
                    maxWidth: '80vw',
                    minHeight: '80vh',
                    maxHeight: '80vh',
                    overflow: 'auto',
                    transform: 'translate(-50%, -50%)',
                    borderRadius: '5px'
                  }
                }}
              >
                <DialogContainer
                  dialogType="edit"
                  dataItem={this.state.batchInEdit}
                  save={this.save}
                  cancel={this.cancel}
                  DownloadBatchReport={this.DownloadBatchReport}
                  toggleStatus={this.toggleStatus}
                  deleteBatch={this.deleteBatch}
                />
              </Modal>
            ) : ""
          }
        </div>
        <div>
          {!this.state.isSubmitted ?
            <BatchesLoader
              dataState={this.state.dataState}
              onDataRecieved={this.dataRecieved}
            />
            : ""
          }
        </div>
        <div>
          {this.state.showMessage ?
            <div className='showMessageContainer'>
              <div className='showMessagePopup'>
                <div className='showMessageText'>{this.state.Message}</div>
                <button onClick={this.closeMessage}>ok</button>
              </div>
            </div>
            : ""
          }
        </div>
      </div>

    );
  }
}

export default ManageBatches;

